// the padding of the container that all site content sits inside
export const layoutPadding = '1.5rem';
export const topbarHeight = '4rem';
